import { logger } from '$utils'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Square Connection loader'
  )
  return defer({
    data: Promise.all([]),
  })
}
